import { useState, useEffect, useCallback } from 'react';

export default function useServerPagination({ perPage, defaultSort, fetchData }) {
  const [activePage, setActivePage] = useState({ page: 1, perPage });
  const [resetPagination, setResetPagination] = useState(false);
  const [sort, setSort] = useState(defaultSort);

  const updateData = () => {
    fetchData({
      page: activePage.page,
      perPage: activePage.perPage,
      sort,
    });
  };

  useEffect(() => {
    updateData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage]);

  useEffect(() => {
    if (activePage.page !== 1) {
      setResetPagination(!resetPagination);
    } else {
      updateData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sort]);

  const onSort = useCallback(({ sortField }, sortDirection) => {
    setSort({ field: sortField, direction: sortDirection });
  }, []);

  return {
    resetPagination,
    setActivePage,
    setSort,
    onSort,
  };
}
